/**
 * 日志工具
 * 提供统一的日志输出接口，可根据环境自动调整日志级别
 */

// 日志级别
var LOG_LEVELS = {
  DEBUG: 0,
  INFO: 1,
  WARN: 2,
  ERROR: 3,
  NONE: 4
};

// 当前日志级别
var currentLevel = process.env.NODE_ENV === 'production' ? LOG_LEVELS.WARN // 生产环境只输出警告和错误
: LOG_LEVELS.DEBUG; // 开发环境输出所有日志

/**
 * 创建日志记录器
 * @param {String} namespace 日志命名空间
 * @returns {Object} 日志记录器对象
 */
export function createLogger(namespace) {
  var prefix = namespace ? "[".concat(namespace, "]") : '';
  return {
    /**
     * 调试日志
     * @param {...any} args 日志参数
     */
    debug: function debug() {
      if (currentLevel <= LOG_LEVELS.DEBUG) {
        var _console;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        (_console = console).debug.apply(_console, [prefix].concat(args));
      }
    },
    /**
     * 信息日志
     * @param {...any} args 日志参数
     */
    info: function info() {
      if (currentLevel <= LOG_LEVELS.INFO) {
        var _console2;
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        (_console2 = console).info.apply(_console2, [prefix].concat(args));
      }
    },
    /**
     * 警告日志
     * @param {...any} args 日志参数
     */
    warn: function warn() {
      if (currentLevel <= LOG_LEVELS.WARN) {
        var _console3;
        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }
        (_console3 = console).warn.apply(_console3, [prefix].concat(args));
      }
    },
    /**
     * 错误日志
     * @param {...any} args 日志参数
     */
    error: function error() {
      if (currentLevel <= LOG_LEVELS.ERROR) {
        var _console4;
        for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          args[_key4] = arguments[_key4];
        }
        (_console4 = console).error.apply(_console4, [prefix].concat(args));
      }
    },
    /**
     * 条件日志
     * 仅在开发环境输出
     * @param {...any} args 日志参数
     */
    dev: function dev() {
      if (process.env.NODE_ENV === 'development') {
        var _console5;
        for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
          args[_key5] = arguments[_key5];
        }
        (_console5 = console).log.apply(_console5, [prefix].concat(args));
      }
    }
  };
}

// 默认日志记录器
export default createLogger('App');